import http from 'hub-http/clients/apiClient';
export const getUser = () => {
  return http.get(`/users/v1/app/user`);
};
export const resendInvites = userIds => http.post('app-users/v1/users/invite/resend', {
  data: {
    userIds
  }
});